export class DoNotAppend {
  message = "This element should not be appended to it's container. This is not an error, but an intended behavior.";
}
